/*
* title: 设置竖图弹窗
* date: 2019/10/31
* author: 比诺
* 功能：
*   -接收套餐、案例等横图默认值
*   -接收自定义文字，如选取套餐横图
*   -裁剪成功、删除的回调函数
*   -弹窗的打开、关闭、状态
*   -本地上传模态框配置
*   -裁剪模态框配置
* */

import Upload from '@common/Upload'
import { ClipModal } from '@hlj/hlj-components'
import { getImageSizeByFile } from '@util'
// import ClipModal from '@common/ClipModal'
import { message, Modal } from 'hljd'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import styles from './index.module.less'
import Store from './store'

@observer
export default class extends Component {
  state = {
    activeClipImage: ''
  }
  constructor(props) {
    super(props)
    this.store = new Store(props)
  }

  useHorizonImg = () => {
    if (!this.props.superImage) {
      return message.warn('请优先上传横图！')
    }
    this.setState({
      activeClipImage: this.props.superImage
    })
    this.store.showVisibleClipModal()
  }

  useLocalImg = res => {
    const { clipUrl } = res
    this.setState({
      activeClipImage: clipUrl
    })
    this.store.showVisibleClipModal()
  }

  onBeforeUp = async file => {
    const { limitWidth, limitHeight } = this.props
    if (!limitWidth || !limitHeight) {
      // 没有限制宽高则默认通过
      return Promise.resolve()
    }
    const { width, height } = await getImageSizeByFile(file.getNative())
    if (width < limitWidth || height < limitHeight) {
      message.error(`图片尺寸太小请重新上传`)
      return Promise.reject()
    }
    return Promise.resolve()
  }

  render() {
    const {
      title,
      visible,
      uploadConfig = {},
      clipModalConfig = {}
    } = this.props
    const {
      vertical_image,
      onCliped,
      onDelete,
      hiddenVisibleClipModal,
      clipModalVisible,
      onOk,
      onCancel
    } = this.store
    const { activeClipImage } = this.state
    return (
      <>
        <Modal
          width={520}
          title="设置竖图"
          visible={visible}
          onOk={onOk}
          onCancel={onCancel}
          footer={null}
          destroyOnClose
        >
          <div className={styles['set-vertical-img']}>
            <Upload
              width={225}
              height={120}
              style={{ borderRadius: '3px' }}
              link={vertical_image}
              autoSizeError={true}
              clipabled
              onBeforeUp={this.onBeforeUp}
              onCliped={this.useLocalImg}
              onDelete={onDelete}
              max_file_size="10mb"
              noUploadMark={true}
              // eslint-disable-next-line no-undef
              javaUpTokenUrl={`${__JAVA__DOMAIN__}/hms/mediacenter/appApi/media/app/token?from=MerchantImage`}
              description={
                <div className={styles['upload_des']}>
                  <div className={styles['upload_add']}>+</div>
                  <p>选取本地图片</p>
                </div>
              }
              filters={{
                mime_types: [
                  {
                    title: 'images files',
                    extensions: 'jpg,gif,png,jpeg,bmp'
                  }
                ],
                max_file_size: '10mb',
                prevent_duplicates: true
              }}
              {...uploadConfig}
            />
            <div
              style={{
                height: 120,
                width: 225,
                border: '1px dashed #d9d9d9',
                color: '#999',
                textAlign: 'center',
                lineHeight: 1.5,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer'
              }}
              onClick={this.useHorizonImg}
            >
              <img
                src="https://qnm.hunliji.com/o_1dovm9h081l3u16ur1sk7slqgb1n.png"
                alt=""
                style={{ width: '40px', marginTop: '8px' }}
              />
              <p style={{ marginTop: '10px', color: '#999' }}>{title}</p>
            </div>
            {/* 裁剪弹窗 */}
          </div>
        </Modal>
        <ClipModal
          onCliped={onCliped}
          visible={clipModalVisible}
          img={activeClipImage}
          onCancel={hiddenVisibleClipModal}
          {...clipModalConfig}
        />
      </>
    )
  }
}
